var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-preparation"},[_c('h3',{staticClass:"title"},[_vm._v("Voorbereiding")]),_vm._v(" "),_c('design-2021-apprentice-display-html-component',{attrs:{"html-content":_vm.preparationIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }